import { Box, Button, Dropdown, Heading, Text } from '@wix/design-system'
import { useContent, useNext, usePageLoading } from '@wix/funnel-builder-lizard'
import { ArrowRight, Chat, Confirm, MagicWand, TaskComplete } from '@wix/wix-ui-icons-common'
import React, { FC, useState } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { WixStudioTemplate } from '../../reusable/WixStudioTemplate/WixStudioTemplate'
import type { Content } from './Content'
import { wixStudioInviteAcceptDataHooks as dataHooks } from './WixStudioInviteAccept.dataHooks'

const SUPPORTED_ICONS: Record<string, FC> = {
  Chat,
  MagicWand,
  TaskComplete,
}

export const WixStudioInviteAccept: FC = () => {
  const [isPageLoading] = usePageLoading()
  const { content } = useContent<Content>()
  const { question } = content
  const [value, setValue] = useState<string | undefined>(undefined)
  const next = useNext()
  const pageLogger = usePageLogger()

  const handleNextClick = () => {
    void pageLogger.answer({ answer: value || '' })
    next({ [question.questionKey]: { values: value ? [value] : [] } })
  }

  return (
    <WixStudioTemplate isPageLoading={isPageLoading} pageLogger={pageLogger} title={content.title}>
      <Box direction="vertical" maxWidth="435px">
        <Box marginTop="50px" marginBottom="60px" direction="vertical">
          <Heading dataHook={dataHooks.subTitle()} size="medium">
            {content.subTitle}
          </Heading>
          {content.description.items.map(({ iconName, text }) => {
            const Icon = SUPPORTED_ICONS[iconName] || Confirm

            return (
              <Box verticalAlign="middle" gap="4px" margin="12px 0 6px" key={text}>
                <Icon />
                <Text>{text}</Text>
              </Box>
            )
          })}
        </Box>
        <Box direction="vertical" marginBottom="44px" gap="12px">
          <Text>{question.content.label}</Text>
          <Dropdown
            dataHook={dataHooks.dropdown()}
            onSelect={({ id }) => setValue(id as string)}
            value={value}
            placeholder={question.content.placeholder}
            size="large"
            options={question.options.map(({ optionKey, label }) => ({ id: optionKey, value: label }))}
          />
        </Box>
      </Box>
      <Box>
        <Button dataHook={dataHooks.next()} onClick={handleNextClick} size="large" suffixIcon={<ArrowRight />}>
          {content.next}
        </Button>
      </Box>
    </WixStudioTemplate>
  )
}
